import { Menu } from "antd";
import classNames from "classnames";
import SVGIcon from "components/v2/Images/SVGIcon";
import React, { useMemo } from "react";

import commonStyles from "../../style.module.css";
import styles from "./style.module.css";

const NestedDropdownItem = ({
  className,
  mode = "vertical",
  items,
  startIcon,
  onClick,
  children,
  disabled,
  nestedDropdownTestId,
}) => {
  const menuItems = useMemo(() => {
    return [
      {
        key: "nestedDropdownItem",
        label: children,
        children: items,
        popupClassName: styles.popupContainer,
        icon: startIcon ? <SVGIcon src={startIcon} className={commonStyles.dropdownItemTitleIcon} /> : null,
        disabled,
      },
    ];
  }, [children, items, startIcon, disabled]);

  return (
    <Menu
      onClick={onClick}
      className={classNames(styles.container, className)}
      mode={mode}
      items={menuItems}
      data-testid={nestedDropdownTestId}
    />
  );
};

export default NestedDropdownItem;
